import { Component, Input } from '@angular/core';

import { DialogService } from '@ngneat/dialog';
import { ApiService, AuthenticatedApiService } from 'rest-client';

import { AuthStateModel } from '@app/modules/core/states/auth-state/auth.model';
import { DIALOG_CONFIG } from '@app/modules/core/utils/dialog.config';

import { GmapsMap, TerminalPlace } from '../../models/gmaps.model';
import { GmapsDialogComponent } from '../gmaps-dialog/gmaps-dialog.component';

@Component({
  selector: 'bkg-summary-location',
  templateUrl: './summary-location.component.html',
})
export class SummaryLocationComponent {
  @Input() imgShow: string;
  @Input() terminalPlace: TerminalPlace;
  @Input() readOnly: boolean;
  @Input() authData: AuthStateModel;
  @Input() isPremium: boolean;
  @Input() vouchers: any;

  constructor(
    private dialog: DialogService,
    private authenticatedApi: AuthenticatedApiService,
    private unauthenticatedApi: ApiService
  ) {
  }

  openMapDialog(): void {
    let gmapConfigPromise: Promise<GmapsMap>;
    if (this.hasAuthData) {
      gmapConfigPromise = this.terminalPlace.terminal_id
        ? this.getMapByTerminalAuth(this.terminalPlace.terminal_id)
        : this.getMapByPlaceAuth(this.terminalPlace.place_id);
    } else {
      gmapConfigPromise = this.terminalPlace.terminal_id
        ? this.getMapByTerminalUnAuth(this.terminalPlace.terminal_id)
        : this.getMapByPlaceUnAuth(this.terminalPlace.place_id);
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    gmapConfigPromise.then((gmapConfig: any) => {
      this.dialog.open(GmapsDialogComponent, {
        ...DIALOG_CONFIG,
        size: 'lg',
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        data: gmapConfig?.map as GmapsMap,
      });
    });
  }

  get hasAuthData(): boolean {
    return !!this.authData.user?.id || !!this.authData.agency?.id;
  }

  private async getMapByTerminalAuth(terminalId: number): Promise<GmapsMap> {
    const result = (await this.authenticatedApi
      .get('product/mapdata/' + terminalId.toString())
      .toPromise()) as GmapsMap;
    return result;
  }

  private async getMapByTerminalUnAuth(terminalId: number): Promise<GmapsMap> {
    const result = (await this.unauthenticatedApi
      .get('product/mapdata/' + terminalId.toString())
      .toPromise()) as GmapsMap;
    return result;
  }

  private async getMapByPlaceAuth(placeId: number): Promise<GmapsMap> {
    const result = (await this.authenticatedApi
      .get('product/mapdata/place/' + placeId.toString())
      .toPromise()) as GmapsMap;
    return result;
  }

  private async getMapByPlaceUnAuth(placeId: number): Promise<GmapsMap> {
    const result = (await this.unauthenticatedApi
      .get('product/mapdata/place/' + placeId.toString())
      .toPromise()) as GmapsMap;
    return result;
  }
}
